import {
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import BASEUtils from "../../../../@BASE/utils";
import { addLesson, removeLesson, updateLesson } from "./lessonSlice";

export const getLessons = createAsyncThunk(
  "lessons/getLessons",
  async (params, { getState }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_SERVICE_URL}/api/lessons`
    );

    const data = await response.data;

    return { data };
  }
);

const lessonsAdapter = createEntityAdapter({});

export const selectSearchText = ({ lessons }) => lessons.list.searchText;

export const { selectAll: selectLessons, selectById: selectLessonsById } =
  lessonsAdapter.getSelectors((state) => state.lessons.list);

export const selectFilteredLessons = createSelector(
  [selectLessons, selectSearchText],
  (lessons, searchText) => {
    if (searchText.length === 0) {
      return lessons;
    }
    return BASEUtils.filterArrayByString(lessons, searchText);
  }
);

const coursesData = state => state.courses.list;

export const selectGroupedFilteredLessons = createSelector(
  [selectFilteredLessons, coursesData],
  (lessons, coursesData) => {
    return lessons
      .sort((a, b) =>
        a.course_id.localeCompare(b.course_id, "es", { sensitivity: "base" })
      )
      .reduce((r, e) => {

        // get first letter of title of current element
        const group = coursesData.entities[e.course_id].title;


        // const group = e.course_id;
        // if there is no property in accumulator with this letter create it
        if (!r[group]) r[group] = { group, children: [e] };
        // if there is push current element to children array for that letter
        else r[group].children.push(e);
        // return accumulator
        return r;
      }, {});
  }
);

const lessonsSlice = createSlice({
  name: "lessons",
  initialState: lessonsAdapter.getInitialState({
    searchText: "",
  }),
  reducers: {
    setLessonsSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
  },
  extraReducers: {
    [updateLesson.fulfilled]: lessonsAdapter.upsertOne,
    [addLesson.fulfilled]: lessonsAdapter.addOne,
    [removeLesson.fulfilled]: (state, action) =>
      lessonsAdapter.removeOne(state, action.payload),
    [getLessons.fulfilled]: (state, action) => {
      const { data, routeParams } = action.payload;
      lessonsAdapter.setAll(state, data);
      state.searchText = "";
    },
  },
});

export const { setLessonsSearchText } = lessonsSlice.actions;

export const selectLessonEntities = ({ lessons }) => lessons.list.entities;

export default lessonsSlice.reducer;
